import React from 'react';

// Styles & Assets
import styles from './PatientImage.module.css';
import defaultUserImg from './../../../assets/common/default-image.svg';

// Interfaces
import { Image } from '../../../interfaces/Patient';

// PatientImage: component that renders a patient's profile image. Props:
//  -image: receives an image or undefined if the image is not available.
const PatientImage: React.FC<{
    image: Image | undefined,
}> = ({ image }) => {

    // loads the image received or a default userImg if it is undefined.
    const patientImgSrc = image && image.data.length < 100000 ?
        `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(image.data)))}`
        :
        defaultUserImg;

    return (
        <>
            {image && image.data.length < 100000 ?
                <div className={styles.imagePatient} style={{ backgroundImage: `url(${patientImgSrc})` }} role='img'></div>
                :
                <img src={patientImgSrc} className={styles.imagePatientIMG} alt='User profile' />
            }
        </>
    );
};

export default PatientImage;